var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',_vm._b({staticClass:"ce-content"},'main',_vm.$attrs,false),[((_vm.isFieldStoreLoaded && _vm.isUnderlyingTranslationLoaded) || _vm.isPageEditMode)?_c('div',{staticClass:"guard-wrap"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }